import React, {ReactNode, useEffect, useRef, useState} from "react";
import {useQuery, useQueryClient} from "react-query";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useGetCentreActuel, useGetOneCentre} from "../features/centre/centre.hooks";
import {useGetActeById} from "../features/acte/acte.hooks";
import DocImg from "../assets/images/icon_doc384x.png";
import XlsImg from "../assets/images/icon_xls384x.png";
import PdfImg from "../assets/images/icon_pdf384x.png";
import IllImg from "../assets/images/icon_img384x.png";
import {format} from "date-fns";
import {getISOWeekNumber, getWeekByDate} from "../components/functions/TimesFunctions";
import {useGetOneUser,useGetUserMob} from "../features/user/user.hooks";



export const useUserConnected = ()=>{
    const queryClient = useQueryClient();
    const userConnected:UserSimple|undefined =  queryClient.getQueryData("user_connected");
    return {userConnected}
}
export const useGetCentreParams = (idCentre:number|null=null, idParams:number)=>{
    const queryClient = useQueryClient();
    const CentreQuery = useGetOneCentre(idCentre||-1)
    const userConnected:UserSimple|undefined =  queryClient.getQueryData("user_connected");
    if(userConnected && !idCentre){
        const Centre = userConnected.Centre;
        const CentreParameters = Centre.parameters;
        const ParametersColor = CentreParameters.find(cp=>cp.Parameter.id === idParams);
        if(ParametersColor){
            return ParametersColor.statut;
        } else {
            return false;
        }
    } else if(idCentre && CentreQuery.data){
        const Centre = CentreQuery.data;
        const CentreParameters = Centre.parameters;
        const ParametersColor = CentreParameters.find(cp=>cp.Parameter.id === idParams);
        if(ParametersColor){
            return ParametersColor.statut;
        } else {
            return false;
        }
    } else {
        return false;
    }
}
export const useGetParamsCentre = (id:number)=>{
    const CentreQuery = useGetCentreActuel()
    const [isParamsOk, setIsParamsOk] = useState<boolean>(false)
    useEffect(() => {
        if(CentreQuery.data){
            const cParameters = CentreQuery.data.parameters;
            const myParams = cParameters.find(cp=>cp.Parameter.id === id);
            setIsParamsOk(!!myParams && myParams.statut)
        }
    }, [CentreQuery.data, id]);
    return {loading:CentreQuery.isLoading, myParamsOk:isParamsOk};
}

export const useGetCentreAnnualise = (idCentre:number|null=null)=>{
    const queryClient = useQueryClient();
    const CentreQuery = useGetOneCentre(idCentre||-1)
    const userConnected:UserSimple|undefined =  queryClient.getQueryData("user_connected");
    if(userConnected && !idCentre){
        const Centre = userConnected.Centre;
        const CentreParameters = Centre.parameters;
        const ParametersColor = CentreParameters.find(cp=>cp.Parameter.id === 6);
        if(ParametersColor){
            return ParametersColor.statut;
        } else {
            return false;
        }
    } else if(idCentre && CentreQuery.data){
        const Centre = CentreQuery.data;
        const CentreParameters = Centre.parameters;
        const ParametersColor = CentreParameters.find(cp=>cp.Parameter.id === 6);
        if(ParametersColor){
            return ParametersColor.statut;
        } else {
            return false;
        }
    } else {
        return false;
    }
}

export const useGetCentreActeColor = (idCentre:number|null=null)=>{
    const queryClient = useQueryClient();
    const CentreQuery = useGetOneCentre(idCentre||-1)
    const userConnected:UserSimple|undefined =  queryClient.getQueryData("user_connected");
    if(userConnected && !idCentre){
        const Centre = userConnected.Centre;
        const CentreParameters = Centre.parameters;
        const ParametersColor = CentreParameters.find(cp=>cp.Parameter.id === 7);
        if(ParametersColor){
            return ParametersColor.statut;
        } else {
            return false;
        }
    } else if(idCentre && CentreQuery.data){
        const Centre = CentreQuery.data;
        const CentreParameters = Centre.parameters;
        const ParametersColor = CentreParameters.find(cp=>cp.Parameter.id === 7);
        if(ParametersColor){
            return ParametersColor.statut;
        } else {
            return false;
        }
    } else {
        return false;
    }
}
export const useGetCentreActeHoraires = (idCentre:number|null=null)=>{
    const queryClient = useQueryClient();
    const CentreQuery = useGetOneCentre(idCentre||-1)
    const userConnected:UserSimple|undefined =  queryClient.getQueryData("user_connected");
    if(userConnected && !idCentre){
        const Centre = userConnected.Centre;
        const CentreParameters = Centre.parameters;
        const ParametersColor = CentreParameters.find(cp=>cp.Parameter.id === 30);
        if(ParametersColor){
            return ParametersColor.statut;
        } else {
            return false;
        }
    } else if(idCentre && CentreQuery.data){
        const Centre = CentreQuery.data;
        const CentreParameters = Centre.parameters;
        const ParametersColor = CentreParameters.find(cp=>cp.Parameter.id === 30);
        if(ParametersColor){
            return ParametersColor.statut;
        } else {
            return false;
        }
    } else {
        return false;
    }
}

export const useGetActeCreneauCentre = ()=>{
    const CentreQuery = useGetCentreActuel();
    const [acte, setActe] = useState<Acte|null>(null);
    const [idActe, setIdActe] = useState<number>(0)
    const ActeQuery = useGetActeById(idActe);
    const [loading, setLoading] = useState(true);
    useEffect(()=>{
        if(CentreQuery.data) {
            const litts: any = CentreQuery.data.literalParameters;
            const idActe = litts.hasOwnProperty('idActeCreneau') ? litts.idActeCreneau : 0;
            setIdActe(idActe);
        }
    }, [CentreQuery.data])
    useEffect(()=>{
        if(ActeQuery.data){
            setActe(ActeQuery.data);
            setLoading(false);
        }
    }, [ActeQuery.data])
    return {loading, acte}
}

export const useGetCentreDayOff = (idCentre:number|null=null)=>{
    const CentreQuery = useGetCentreActuel();
    const CentreQQuery = useGetOneCentre(idCentre||-1)
    const [numDayOffCentre, setNumDayOffCentre] = useState<number[]>([])
    const TabJT:{lib:string, open:boolean, numDay:number}[]=[
        {lib:'L', open:false, numDay:1},
        {lib:'M', open:false, numDay:2},
        {lib:'Me', open:true, numDay:3},
        {lib:'J', open:true, numDay:4},
        {lib:'V', open:true, numDay:5},
        {lib:'S', open:true, numDay:6},
        {lib:'D', open:false, numDay:0},
    ]
    useEffect(()=>{
        if(CentreQuery.data && !idCentre){
            const litts:any  = CentreQuery.data.literalParameters;
            const Opens = litts.hasOwnProperty('opens') ? litts.opens : null;
            let MyTabJ:number[] = [];
            if(Opens){
                TabJT.forEach(j=>{
                    if(Opens[j.lib] === 0){
                        MyTabJ.push(j.numDay);
                    }
                })
                setNumDayOffCentre(MyTabJ);
            }

        } else if(CentreQQuery.data && idCentre){
            const litts:any  = CentreQQuery.data.literalParameters;
            const Opens = litts.hasOwnProperty('opens') ? litts.opens : null;
            let MyTabJ:number[] = [];
            if(Opens){
                TabJT.forEach(j=>{
                    if(Opens[j.lib] === 0){
                        MyTabJ.push(j.numDay);
                    }
                })
                setNumDayOffCentre(MyTabJ);
            }
        }
    }, [CentreQuery.data, CentreQQuery.data])

    return {isLoading:CentreQuery.isLoading , days:numDayOffCentre};
}

export const useModal = ()=>{
    const [show, setShow] = useState(false);
    const [waiting, setWaiting] = useState(false);

    function toggle() {
        setShow(show=>!show);
    }
    function waitForIt(){

        setWaiting(waiting=>!waiting);
    }
    return {show,toggle, waiting, waitForIt};
}
export const useGetWeekDate = (dat:string|null)=>{
    const [dateStart, setDateStart] = useState<Date|null>(null);
    const [dateEnd, setDateEnd] = useState<Date|null>(null);
    const [isCalculate, setIsCalculate] = useState(true);
    useEffect(()=>{
        setIsCalculate(true);
        if(dat!==null){
            const DatDat = new Date(dat);
            const numDayDate = DatDat.getDay() === 0 ? 6 : DatDat.getDay()-1;
            const DateStart = new Date(DatDat.getTime() - (numDayDate*86400000));
            const DateEnd = new Date(DateStart.getTime() + (6*86400000));
            setDateStart(DateStart);
            setDateEnd(DateEnd);
            setIsCalculate(false);
        }
    }, [dat])
    return {isCalculate, dateStart, dateEnd};
}


export function useDebounce<T>(value: T, delay: number): T {
    // State and setters for debounced value
    const [debouncedValue, setDebouncedValue] = useState<T>(value);

    useEffect(
        () => {
            // Update debounced value after delay
            const handler = setTimeout(() => {
                setDebouncedValue(value);
            }, delay);

            // Cancel the timeout if value changes (also on delay change or unmount)
            // This is how we prevent debounced value from updating if value is changed ...
            // . . within the delay period. Timeout gets cleared and restarted.
            return () => {
                clearTimeout(handler);
            };
        },
        [value, delay] // Only re-call effect if value or delay changes
    );

    return debouncedValue;
}

export const useSetSmartNavBar = ()=>{
    const [searchParams, setSearchParams] = useSearchParams();
    const setParams = (vals:{key:string, value:string|number}[])=>{
        const TabParams = [...Array.from(searchParams)];
        let myParams: any = {
            from:  '',
            to:  '',
            lieu:  '',
            fx:'',
            idCollab:'',
            vues:'',
            index: '0'
        };
        TabParams.forEach(item=>{
            const Find = vals.find(i=>i.key === item[0]);
            if(!Find){
                myParams[item[0]] = item[1];
            }
        })
        for (const [k,v] of Object.entries(myParams)){
            const Find = vals.find(i=>i.key === k);
            if(Find){
                if(Find.value === ''){
                    delete myParams[k];
                } else {
                    myParams[k] = Find.value
                }
            } else if(v===''){
                delete myParams[k];
            }
        }
        setSearchParams(myParams);
    }
    return {setParams}
}

function getProfileData() {
    return localStorage.getItem('__centre_connected__') ? JSON.parse(localStorage.getItem('__centre_connected__')||'') : '0';
}

export function useCentreConnectedData() {
    const [idcentre, setidCentre] = useState<number|null>(null);
    useEffect(() => {
        setidCentre(parseInt(getProfileData()));
        function handleChangeStorage() {
            setidCentre(parseInt(getProfileData()));
        }

        window.addEventListener('storage', handleChangeStorage);
        return () => window.removeEventListener('storage', handleChangeStorage);
    }, []);

    return idcentre;
}

export const useGetParams = ()=>{
    const [searchParams] = useSearchParams();
    const [TabFrom, setTabFrom] = useState<string|undefined>(undefined);
    const [TabTo, setTabTo] = useState<string|undefined>(undefined);
    const [TabLieu, setTabLieu] = useState<string|undefined>(undefined);
    const [TabFx, setTabFx] = useState<string|undefined>(undefined);
    const [TabCollab, setTabCollab] = useState<string|undefined>(undefined);
    const [TabVues, setTabVues] = useState<string|undefined>(undefined);
    useEffect(()=>{
        const TabParamsB = [...Array.from(searchParams)];
        const TabFromx = TabParamsB.find(tab => tab[0] === 'from');
        const TabTox = TabParamsB.find(tab => tab[0] === 'to');
        const TabLieux = TabParamsB.find(tab => tab[0] === 'lieu');
        const TabFxx = TabParamsB.find(tab => tab[0] === 'fx');
        const TabCollabx = TabParamsB.find(tab => tab[0] === 'idCollab');
        const TabVuesx = TabParamsB.find(tab=>tab[0]==='vues');
        setTabFrom(TabFromx ? TabFromx[1] : undefined)
        setTabTo(TabTox ? TabTox[1] : undefined)
        setTabLieu(TabLieux ? TabLieux[1] : undefined)
        setTabFx(TabFxx ? TabFxx[1] : undefined)
        setTabCollab(TabCollabx ? TabCollabx[1] : undefined)
        setTabVues(TabVuesx ? TabVuesx[1] : undefined)
    }, [searchParams])
    return {TabFrom, TabTo, TabFx, TabLieu, TabVues, TabCollab}
}

/**
 * Un abonnement SSE, tenu par un effet.
 *
 * La version precedente ouvrait l'`EventSource` DANS la fonction de requete de
 * react-query, et ne le fermait jamais. Trois consequences :
 *
 * - react-query rejoue sa fonction quand la donnee devient obsolete, au retour
 *   sur l'onglet, apres une erreur : chaque rejeu ouvrait un flux de plus ;
 * - aucun de ces flux n'etait ferme, ni au rejeu ni au demontage ;
 * - la valeur rendue etait figee, puisque la fonction retournait avant que le
 *   premier evenement n'arrive.
 *
 * Le hub voyait 2582 abonnements pour 2581 deconnexions sur 20 000 lignes de
 * journal, un topic reabonne jusqu'a 360 fois. Chaque cycle refait une
 * negociation TLS et un tunnel dans le proxy -- d'ou des connexions qui
 * mettaient jusqu'a 2,6 s a s'etablir, la ou le hub repond en 0,9 ms.
 *
 * `topics` est fige en une chaine pour la comparaison de dependances : un
 * tableau litteral change de reference a chaque rendu.
 */
export const useEventSourceQuery = (
    url: URL,
    topics: string[],
    eventCallback: {
        eventName: "message" | "open" | "error";
        callback: (event: MessageEvent) => any;
    },
    queryKey?: any
) => {
    const [data, setData] = useState<any>({
        data: "Aucune donnée n'a été renvoyée par la callback function",
    });

    const rappel = useRef(eventCallback);
    rappel.current = eventCallback;

    const cle = `${url.origin}${url.pathname}|${topics.join(",")}`;

    useEffect(() => {
        const cible = new URL(url.toString());
        for (const topic of topics) {
            cible.searchParams.append("topic", topic);
        }

        const evtSource = new EventSource(cible);
        evtSource.addEventListener(rappel.current.eventName as string, (event) => {
            setData(rappel.current.callback(event as MessageEvent));
        });

        return () => evtSource.close();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cle]);

    return data;
};

export const useTimedSortable = (defaultChoice:Choice, sensDefault:1|-1=-1)=>{
    const [sortSens, setSortSens] = useState<1|-1>(sensDefault)
    const [filterSort, setFilterSort] = useState<Choice>(defaultChoice)
    const handleChangeSort = (chx:Choice)=>{
        if(chx.id === filterSort.id){
            setSortSens(s=>s === 1 ? -1 : 1)
        } else{
            setFilterSort(chx)
        }
    }
    return {sortSens, handleChangeSort, filterSort}
}
export const GetImageDocByExt = (ext:string|null)=>{
    const TabWord = ['docx', 'doc', 'odt'];
    const TabExcel = ['xlsx', 'xls', 'xl'];
    const TabPDF = ['PDF', 'pdf'];
    const TabImg = ['png', 'jpg', 'jpeg', 'JPEG']
    if(!ext){
        return <></>
    }
    if(TabWord.indexOf(ext)!==-1){
        return <img className={"image_log"} src={DocImg} alt={"icon_doc"}/>;
    } else if(TabExcel.indexOf(ext)!==-1){
        return <img className={"image_log"} src={XlsImg} alt={"icon_xls"}/>;
    } else if(TabPDF.indexOf(ext)!==-1){
        return <img className={"image_log"} src={PdfImg} alt={"icon_pdf"}/>;
    } else if(TabImg.indexOf(ext)!==-1){
        return <img className={"image_log"} src={IllImg} alt={"icon_image"}/>;
    } else {
        return <img className={"image_log"} src={DocImg} alt={"icon_doc"}/>;
    }
}



export const useGetImageDocument = (ext:string|null)=>{
    const TabWord = ['docx', 'doc', 'odt'];
    const TabExcel = ['xlsx', 'xls', 'xl'];
    const TabPDF = ['PDF', 'pdf'];
    const TabImg = ['png', 'jpg', 'jpeg', 'JPEG']
    const [myIcon, setMyIcon] = useState<ReactNode|null>(null)
    const getIcon = (ext:string)=>{
        if(TabWord.indexOf(ext)!==-1){
            return <img src={DocImg} alt={"icon_doc"}/>;
        } else if(TabExcel.indexOf(ext)!==-1){
            return <img src={XlsImg} alt={"icon_xls"}/>;
        } else if(TabPDF.indexOf(ext)!==-1){
            return <img src={PdfImg} alt={"icon_pdf"}/>;
        } else if(TabImg.indexOf(ext)!==-1){
            return <img src={IllImg} alt={"icon_image"}/>;
        } else {
            return <img src={DocImg} alt={"icon_doc"}/>;
        }
    }
    useEffect(() => {
        if(!ext){
            setMyIcon(null);
        } else {
            setMyIcon(getIcon(ext))
        }
    }, [ext]);

    return {Image:myIcon};
}
export interface OneDayLib{
    numJ:number;
    numStd:number;
    libelle:string;
}
interface InfosDay extends OneDayLib{
    strDate:string;
}
export const TabDay:OneDayLib[] = [
    {numJ:0, numStd:7, libelle:"Dimanche"},
    {numJ:1, numStd:1, libelle:"Lundi"},
    {numJ:2, numStd:2, libelle:"Mardi"},
    {numJ:3, numStd:3, libelle:"Mercredi"},
    {numJ:4, numStd:4, libelle:"Jeudi"},
    {numJ:5, numStd:5, libelle:"Vendredi"},
    {numJ:6, numStd:6, libelle:"Samedi"},
]
export const useGetInfosDay = (d:Date)=>{
    const [myDayInfos, setMyDayInfos] = useState<InfosDay>({numJ:-1, numStd:-1, libelle:"nc", strDate:""})
    useEffect(() => {
        const myDay = TabDay.find(day=>day.numJ === d.getDay())
        if(myDay){
            const myDateStr = format(d, "dd/MM/yyyy")
            setMyDayInfos({...myDay, strDate:myDateStr})
        }
    }, [d]);
    return {...myDayInfos}
}

export const useGetLittsCentre = (key:string)=>{
    const CentreQuery = useGetCentreActuel()
    const [myLitts, setMyLitts] = useState<any|null>(null)
    useEffect(() => {
        if(CentreQuery.data){
            const litts = CentreQuery.data.literalParameters;
            if (key in litts) {
                setMyLitts(litts[key as keyof typeof litts]);
            }
        }
    }, [CentreQuery.data, key]);
    return {loading:CentreQuery.isLoading, value:myLitts}
}
export interface DateSetter{
    from:Date;
    to:Date;
    numWeek:number;
}

export const useGetDateWeekParams = ()=>{
    const [searchParams] = useSearchParams();
    const [dateSetter, setDateSetter] = useState<DateSetter|null>(null)
    useEffect(() => {
        let fromFr = "";
        searchParams.forEach((key, value) => {
            if(value === "from"){
                fromFr = key;
            }
        });
        let RetourDateWeek = getWeekByDate(new Date((new Date()).setHours(12,0,0)))
        if(fromFr !== ""){
            const TabDaty = fromFr.split('/');
            const TabStrDaty = `${TabDaty[2]}-${TabDaty[1]}-${TabDaty[0]} 12:00:00`;
            RetourDateWeek = getWeekByDate(new Date(TabStrDaty))
        }
        setDateSetter({from:RetourDateWeek.Monday, to:RetourDateWeek.Sunday, numWeek:getISOWeekNumber(RetourDateWeek.Monday)})
    }, [searchParams]);
    return dateSetter;
}

export const useGetCGL = ()=>{
    const UserQuery = useGetUserMob();
    const [CGL, setCGL] = useState<CGL|null>(null);
    useEffect(() => {
        if(UserQuery.data && UserQuery.data.CGL){
            setCGL(UserQuery.data.CGL)
        }
    }, [UserQuery]);
    return {CGL, setCGL}
}

export const useGetCollabPage = ()=>{
    const [searchParams] = useSearchParams();
    const [User, setUser] = useState<User|null|undefined>(undefined)
    const [idUser, setIdUser] = useState<number>(0)
    const UserConcernedQuery = useGetOneUser(idUser)
    const navigate = useNavigate();
    useEffect(() => {
        if(UserConcernedQuery.data) setUser(UserConcernedQuery.data)
    }, [UserConcernedQuery.data]);
    useEffect(() => {
        if(!UserConcernedQuery.isLoading && !UserConcernedQuery.data && idUser!==0){
            navigate("../fiche_personnel")
        }
    }, [UserConcernedQuery.isLoading, UserConcernedQuery.data, idUser]);
    /*
     * On LIT le parametre. On ne renavigue pas dessus.
     *
     * Cet effet appelait `navigate("../fiche_personnel?idCollab=" + idCollabStr)`
     * — c'est-a-dire qu'il naviguait vers l'adresse ou l'on se trouvait deja,
     * puisque c'est de la qu'il tirait `idCollabStr`. Chaque navigation produit
     * un nouvel objet `searchParams`, donc la dependance changeait, donc l'effet
     * repartait : une boucle sans fin. A chaque tour, un rendu — l'ecran
     * scintillait —, une entree d'historique, un enregistrement de monitoring de
     * navigation, et un reabonnement Mercure.
     *
     * Cette ligne faisait deux degats de plus, silencieux ceux-la. Les huit
     * ecrans qui menent ici passent tous `?idCollab=` :
     *
     *     CollabNoContrat    /fiche_personnel/contrats?idCollab=…
     *     OnePlagePlanning   /fiche_personnel?idCollab=…&From=…
     *
     * La renavigation ecrasait la sous-route `contrats` et perdait le parametre
     * `From`. Quelqu'un qui cliquait pour arriver sur les contrats atterrissait
     * sur la racine de la fiche.
     */
    useEffect(() => {
        const idCollabStr = searchParams.get("idCollab");
        if(idCollabStr){
            setIdUser(parseInt(idCollabStr))
        } else {
            setIdUser(0);
            setUser(null);
        }
    }, [searchParams]);

    return {User};
}
